
import { Nav } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
// @ts-ignore
import '../OpportunityFunnelV2.scss';
import RequiredFormLabel from 'src/components/RequiredFormLabel/RequiredFormLabel';
import { FunnelStep } from '../types';

type OpportunityFunnelTabProps = {
  forceRequired?: boolean;
  showIsOptional?: boolean;
  eventKey: string;
  title: string;
  text: string;
  mustComplete: FunnelStep[];
  isValid?: boolean;
}

export const OpportunityFunnelTab = ({
  title,
  text,
  eventKey,
  isValid = false,
  mustComplete,
  forceRequired = false,
  showIsOptional
}: OpportunityFunnelTabProps) => {

  const isRequired = showIsOptional === true ? false : (forceRequired || mustComplete.includes(eventKey as FunnelStep));

  return (
    <Nav.Item>
      <Nav.Link eventKey={eventKey} className='text-start text-muted text-success'>
        <div>
          {isValid && <span><FaCheck className='text-success'></FaCheck> &nbsp;</span>}
          <b>
            <RequiredFormLabel
              label={title}
              required={isRequired}
            />
          </b>
        </div>
        <div className='text-sm'>
          {text}
        </div>
      </Nav.Link>
    </Nav.Item>
  )
}


export default OpportunityFunnelTab;
